import React, { useState,useEffect, useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';
async function toDataURL(src) {
  const blob = await fetch(src, { cache: 'reload' }).then(r => r.blob());
  return new Promise(res => {
    const reader = new FileReader();
    reader.onload = () => res(reader.result);
    reader.readAsDataURL(blob);
  });
}
export function CertificateViewer(props) {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const images = props.images || [];
  const [dataUrls, setDataUrls] = useState([]);         // holds Base64 URLs

  // 1. Watch prop.images, convert each to DataURL
  useEffect(() => {
    let mounted = true;
    Promise.all(images.map(toDataURL))
        .then(urls => {
          if (mounted) setDataUrls(urls);
        })
        .catch(err => {
          console.error('Failed to fetch images as data URLs', err);
        });
    return () => { mounted = false; };
  }, [images]);
  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1024px)").matches
  )

  useEffect(() => {
    window
    .matchMedia("(min-width: 1024px)")
    .addEventListener('change', e => setMatches( e.matches ));
  }, []);

  return (
      <div>
        {images.map((origSrc, i) => {
          const src = dataUrls[i] || origSrc;  // show orig until Base64 is ready
          return (
              <img
                  key={origSrc + i}
                  src={src}
                  onClick={() => openImageViewer(i)}
                  width={matches ? '500' : '200'}
                  style={{ margin: '5px', cursor: 'pointer' }}
                  alt=""
              />
          );
        })}

        {isViewerOpen && (
            <ImageViewer
                src={dataUrls.length === images.length ? dataUrls : images}
                currentIndex={currentImage}
                disableScroll={false}
                closeOnClickOutside={true}
                onClose={closeImageViewer}
            />
        )}
      </div>
  );
}
